import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { getPAGAA000, postPAGAA010Volunteer } from '../../../services/Api';
import Nav from '../../../shared/components/Nav';
import Pagination from '../../../shared/components/Pagination';
import { MENU_DENTAL_PLUS } from '../../../shared/constants/app';
import { formatDate, updateMenuVisibility } from '../../../utils';
import useWindowWidth from '../../../shared/hooks/useWindowWidth';

const PAGAA010 = () => {
    const [listVolunteer, setListVolunteer] = useState({});
    const [listCountNotOption, setListCountNotOption] = useState({});
    const [searchParams, setSearchParam] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;
    const [isEnd, setIsEnd] = useState('N');
    const [pages, setPages] = useState({});
    const [dentalPlusMenu, setDentalPlusMenu] = useState([]);
    // const [keywords, setKeywords] = useState('');

    const [itemFilter, setItemFilter] = useState([
        { label: '모집중', key: 'opened', value: 'N', active: 1 },
        { label: '마감', key: 'closed', value: 'Y', active: 0 },
        { label: '전체', key: 'total', value: '', active: 0 },
    ]);
    // const handleKeyDown = (e) => {
    //     if (e.key === 'Enter') {
    //         getListData();
    //         getListDataNotOption();
    //     }
    // };

    useEffect(() => {
        getPAGAA000()
            .then(({ data }) => {
                const updatedDentalPlusMenu = updateMenuVisibility(data, MENU_DENTAL_PLUS);
                setDentalPlusMenu(updatedDentalPlusMenu);
            })
            .catch((error) => console.log(error));
    }, []);

    const handleChangeIsEnd = (e) => {
        const dataIsEnd = e.currentTarget.dataset.value;

        setItemFilter((prevFilters) =>
            prevFilters.map((item) => ({
                ...item,
                active: item.value === dataIsEnd ? 1 : 0,
            })),
        );

        if (isEnd !== dataIsEnd) {
            setIsEnd(dataIsEnd);
            setSearchParam(1);
        }
    };

    // const handleSearch = () => {
    //     getListData();
    //     getListDataNotOption();
    // };

    // const handleChangeSeach = (e) => {
    //     const keywords = e.target.value;
    //     setKeywords(keywords);
    // };

    const getListData = () => {
        postPAGAA010Volunteer({
            page,
            options: { ...(isEnd ? { isEnd: [isEnd] } : {}) },
            // keyword: keywords,
        })
            .then(({ data }) => {
                setListVolunteer(data.data.volunteer);
                setPages(data.info);
            })
            .catch((error) => console.log(error));
    };

    const getListDataNotOption = () => {
        postPAGAA010Volunteer({
            page,
            // keyword: keywords,
        })
            .then(({ data }) => {
                setListCountNotOption(data.data.counts);
            })
            .catch((error) => console.log(error));
    };

    useEffect(() => {
        getListData();
        //eslint-disable-next-line
    }, [page, isEnd]);

    useEffect(() => {
        getListDataNotOption();
        //eslint-disable-next-line
    }, [isEnd]);
    const windowWidth = useWindowWidth();
    return (
        <div id="content">
            <Nav menu={dentalPlusMenu} />
            <div id="volunteerBannerImg">
                <div className="bannerImg" />
                <div className="titleBannerImg">
                    <span className="title-child1">자원봉사 모집 광고는 덴탈잡이 기부합니다.</span>
                    <span className="title-child2"> 무료로 이용하세요!</span>{' '}
                    <span className="title-child3">
                        <i className="icon icon-phone-active" />
                        080-801-1580
                    </span>
                </div>
            </div>
            <div id="tableVolunteer">
                <div className="header-table">
                    <div className="header-left">
                        {itemFilter.map((item) => (
                            <div
                                key={item.key}
                                className={`item-header ${item.active ? 'active' : ''}`}
                                data-value={item.value}
                                onClick={handleChangeIsEnd}
                            >
                                {item.label} (<span>{listCountNotOption?.[item.key] || 0}</span>)
                            </div>
                        ))}
                    </div>
                    {/* <div className="header-right gray">
                        <input
                            type="text"
                            placeholder="검색어 입력"
                            value={keywords}
                            onChange={handleChangeSeach}
                            onKeyDown={handleKeyDown}
                        />
                        <i className="icon icon-magnifying-glass-line pointer" onClick={handleSearch} />
                    </div> */}
                </div>
                <div className="content-table PAGAA010">
                    <div className="flex wrap-item">
                        <div className="head-item">모집기관명</div>
                        <div className="head-item">제목</div>
                        <div className="head-item">지역</div>
                        <div className="head-item">모집기간</div>
                    </div>
                    {listVolunteer && listVolunteer.length > 0 ? (
                        listVolunteer.map((item, index) => {
                            return (
                                <React.Fragment key={item.seq}>
                                    <div className="flex wrap-item body-item">
                                        <div className="content-item">
                                            <Link to={`/pagaa020-${item?.seq}`}>{item?.agency}</Link>
                                        </div>
                                        <div className="title-item">
                                            <Link to={`/pagaa020-${item?.seq}`}>{item?.title}</Link>
                                        </div>
                                        {windowWidth > 768 ? (
                                            <>
                                                <div className="location-item">{item?.location}</div>
                                                <div className="date-item">
                                                    {item?.isIndefinite === 'Y'
                                                        ? '상시모집'
                                                        : item?.isIndefinite === 'N'
                                                            ? `~${formatDate(item.endDate)}`
                                                            : ''}
                                                </div>
                                            </>
                                        ) : (
                                            <div style={{ display: 'flex', width: '100%' }}>
                                                {item?.location && (
                                                    <div className="location-item">{item?.location}</div>
                                                )}
                                                <div className={`date-item ${item?.location ? 'only-date-item' : ''}`}>
                                                    {item?.isIndefinite === 'Y'
                                                        ? '상시모집'
                                                        : item?.isIndefinite === 'N'
                                                            ? `~${formatDate(item.endDate)}`
                                                            : ''}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </React.Fragment>
                            );
                        })
                    ) : (
                        <div style={{ textAlign: 'center', marginTop: '20px' }}> 데이터없습니다 </div>
                    )}
                </div>
                <Pagination pages={pages} />
            </div>
        </div>
    );
};

export default PAGAA010;
